(()=>{
 const panel=document.getElementById('dp-preview-offer');if(!panel)return;
 const key='dp.preview.offer.v1',subscribed='dp.newsletter.subscribed',limit=240000;
 let readyAt=null,seen=false,stopped=false;
 const read=(store,k)=>{try{return store.getItem(k);}catch{return null;}};
 const write=(store,k,v)=>{try{store.setItem(k,v);}catch{}};
 seen=!!read(sessionStorage,key);stopped=panel.dataset.subscribed==='true'||!!read(localStorage,subscribed);
 const roots=()=>[document,...Array.from(document.querySelectorAll('*')).map(e=>e.shadowRoot).filter(Boolean)];
 const matches=selector=>roots().flatMap(r=>Array.from(r.querySelectorAll(selector)));
 const track=(name,attempt=0)=>{
  try{
   const shop=window.Shopify;
   if(!shop?.customerPrivacy?.currentVisitorConsent||!shop?.analytics?.publish){if(attempt<20)setTimeout(()=>track(name,attempt+1),500);return;}
   if(shop.customerPrivacy.currentVisitorConsent().analytics!=='yes')return;
   const eventKey=key+':'+name;
   if(read(sessionStorage,eventKey))return;
   write(sessionStorage,eventKey,'1');
   Promise.resolve(shop.analytics.publish(name,{source:'preview_newsletter_offer',placement:'configurator',seconds:240}))
    .catch(()=>{try{sessionStorage.removeItem(eventKey);}catch{}});
  }catch{}
 };
 const show=()=>{panel.hidden=false;if(!panel.open)panel.showModal();};
 const hide=()=>{if(panel.open)panel.close();panel.hidden=true;};
 const dismiss=()=>{seen=true;write(sessionStorage,key,'shown');hide();};
 panel.querySelectorAll('[data-offer-close]').forEach(b=>b.addEventListener('click',dismiss));
 panel.addEventListener('cancel',e=>{e.preventDefault();dismiss();});
 // Cart opening is sticky for this visit: do not interrupt an existing purchase intention.
 const cart=document.getElementById('dear-cart-drawer');
 const suppress=()=>{if(cart?.open){stopped=true;write(sessionStorage,key,'cart');hide();}};
 if(cart)new MutationObserver(suppress).observe(cart,{attributes:true,attributeFilter:['open']});suppress();
 document.addEventListener('click',e=>{if(e.composedPath().some(n=>n instanceof Element&&n.matches('[data-cart-checkout],a[href*="/checkout"]'))){stopped=true;write(sessionStorage,key,'checkout');hide();}},true);
 const timer=setInterval(()=>{
  if(seen||stopped){clearInterval(timer);return;}
  // Start once the preview returns; scrolling away or backgrounding does not pause it.
  if(readyAt===null){
   const ready=matches('.dp-photo-gallery[aria-busy="false"]').some(g=>{
    const imgs=Array.from(g.querySelectorAll('.dp-photo-tile img'));
    return !g.hidden&&imgs.length===2&&imgs.every(i=>!i.hidden&&i.getAttribute('src'));
   });
   if(!ready)return;
   readyAt=Date.now();
  }
  if(Date.now()-readyAt<limit||document.visibilityState!=='visible'||matches('dialog[open]').length)return;
  seen=true;write(sessionStorage,key,'shown');show();track('dp_newsletter_offer_viewed');
 },1000);
 const form=panel.querySelector('form'),feedback=panel.querySelector('[data-offer-feedback]');
 // Let Shopify handle its native customer form, including spam protection.
 form.addEventListener('submit',()=>{if(form.reportValidity())feedback.textContent=panel.dataset.saving;});
 if(form.querySelector('[data-offer-subscribed]')){
  track('dp_newsletter_subscribed');
  write(localStorage,subscribed,'true');stopped=true;seen=true;write(sessionStorage,key,'subscribed');
  form.hidden=true;show();feedback.textContent=panel.dataset.saving;
  const clean=new URL(location.href);clean.searchParams.delete('customer_posted');if(clean.hash==='#dp-offer-form')clean.hash='';history.replaceState(history.state,'',clean);
  panel.querySelectorAll('[data-offer-close]').forEach(b=>{if(b.classList.contains('dp-offer-dismiss'))b.textContent=panel.dataset.done;});
  fetch('/discount/VALKOMMEN10?redirect='+encodeURIComponent(location.pathname),{credentials:'same-origin'})
   .then(response=>{feedback.textContent=response.ok?panel.dataset.success:panel.dataset.discountFallback;})
   .catch(()=>{feedback.textContent=panel.dataset.discountFallback;});
 }else if(form.querySelector('[data-offer-errors]')){show();}
})();
